import { ComponentCreator, CCMDefinition } from './types';

export const CCM_DEFINITION = Symbol.for('ccm.definition');

export const getCCMDefinition = (ccm: ComponentCreator<any>): CCMDefinition =>
  (ccm as any)[CCM_DEFINITION];
